import {
  IntegerInputControl,
  RealInputControl,
} from '../../../../../../types/types';
import { getDefaultNumericFilterValue } from '../../../../../../utils/managerUtils';

export const getDefaultValue = (
  control: IntegerInputControl | RealInputControl,
  opensEmpty: boolean
) => {
  // Column (quick) filter opens empty like every other filter type
  if (opensEmpty) {
    return '';
  }

  return getDefaultNumericFilterValue(control);
};
